import { render, staticRenderFns } from "./app-clean.vue?vue&type=template&id=22e1e9a5"
import script from "./app-clean.vue?vue&type=script&lang=js"
export * from "./app-clean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports